module.exports = __webpack_public_path__ + "img/logo.773545b6.jpg";